<template>
    <transition name="overlay-transition">
        <div class="overlay" v-show="shouldShow">
            <div class="overlay-slot">
                <div class="overlay-body">
                    <slot></slot>
                </div>
            </div>

            <button class="overlay-close" @click="onClickClose">
                <span class="icon icon-close-thick"></span>
            </button>
        </div>
    </transition>
</template>

<script src="./overlay.js"></script>
